// src/modules/app-views/_apps/applekkus/landingPages/pages/Init/actions/actionButton.js

import { PlusOutlined } from '@ant-design/icons';

const landingPagesInitActionButton = () => {
  return {
    action: 'new',
    hideButton: false,
    label: 'new',
    tooltip: 'new_landing_page',
    icon: <PlusOutlined />,
    type: 'primary',
    disabled: false,

    // Primary button handler - navigation to add new document
    onClick: ({ navigate, setPage }) => {
      setPage({
        navigate,
        pageName: 'document',
        params: { _id: 'add' },
      });
    },

    // No dropdown for this button
    dropdownItems: [],
  };
};

export default landingPagesInitActionButton;
